module.exports = __webpack_public_path__ + "img/3-1.cb17a71c.svg";